module.exports = __webpack_public_path__ + "41ea1c2ad348a85a8ba91c9b15a3beea.jpg";